module.exports = __webpack_public_path__ + "img/logo_ssparisi.ab1399fd.png";